import { render, staticRenderFns } from "./DeliveryReminderList.vue?vue&type=template&id=798a71b7"
import script from "./DeliveryReminderList.vue?vue&type=script&lang=js"
export * from "./DeliveryReminderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports